import script from "./SerpPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./SerpPage.vue?vue&type=script&setup=true&lang=ts"

import "./SerpPage.vue?vue&type=style&index=0&id=49e8691c&lang=css"

const __exports__ = script;

export default __exports__